import { getIsThemePreview, getPortalAccountId, getPortalInstanceId, getPreviewJwt } from './utils/metadata';
// @ts-ignore Untyped module
import Cookies from 'js-cookie';
const isThemePreview = getIsThemePreview();
const previewJwt = getPreviewJwt();
export default function createPortalsFetchClient(prefix) {
  return function portalsFetchClient(input, init) {
    var _Cookies$get;
    const originalBody = JSON.parse(init.body.toString());
    let clientInfo = {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    };
    if (isThemePreview) {
      clientInfo = {
        previewJwt
      };
    }
    return fetch(`${prefix}${input}`, {
      method: 'POST',
      headers: Object.assign({}, init.headers, {
        'X-Hs-Membership-Csrf': (_Cookies$get = Cookies.get('__Host-hs-membership-csrf')) !== null && _Cookies$get !== void 0 ? _Cookies$get : Cookies.get('hs-membership-csrf')
      }),
      body: JSON.stringify(Object.assign({}, originalBody, clientInfo))
    });
  };
}